export default {
      id: "arrow-in-circle-usage",
      viewBox: "0 0 86 86",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-in-circle",
      toString: function () {
        return this.url;
      }
    }